export default __webpack_public_path__ + "static/media/project_dashboards.6f86f907.png";